"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5799],{

/***/ 32909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$T": function() { return /* binding */ LogoBig; },
/* harmony export */   "$l": function() { return /* binding */ DocumentIcon; },
/* harmony export */   "QP": function() { return /* binding */ ActivityTrackerIcon; },
/* harmony export */   "TR": function() { return /* binding */ Logo; },
/* harmony export */   "Xd": function() { return /* binding */ ArrowLeft; },
/* harmony export */   "_v": function() { return /* binding */ ArrowTopRight; },
/* harmony export */   "by": function() { return /* binding */ HelpIcon; },
/* harmony export */   "mP": function() { return /* binding */ PaperWorkIcon; },
/* harmony export */   "tv": function() { return /* binding */ HomeIcon; }
/* harmony export */ });
/* unused harmony exports ChevronDown, ArrowDownAlt */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChevronDown = function() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "10",
        height: "6",
        viewBox: "0 0 10 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M9.29492 1.34662L5.002 4.65726L0.705078 1.34271",
            stroke: "#8A8D93",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var ArrowDownAlt = function() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12.3042 8.00551L8.00424 12.2804M8.00424 12.2804L3.70699 7.98325M8.00424 12.2804L8.00425 3.69455",
            stroke: "#424750",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var ArrowLeft = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "10",
        height: "11",
        viewBox: "0 0 10 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4.97789 10.2876L0.702954 5.9877M0.702954 5.9877L5.00015 1.69045M0.702954 5.9877L9.28885 5.9877",
            stroke: "#2CA58D",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var ArrowTopRight = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4.96382 4.94418L11.0272 4.96187M11.0272 4.96187L11.0272 11.0391M11.0272 4.96187L4.95602 11.033",
            stroke: "#2CA58D",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var DocumentIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.7 10.5355C6.7 10.0142 6.70173 9.82623 6.72257 9.67859C6.86582 8.66354 7.66354 7.86582 8.67859 7.72257C8.82623 7.70173 9.01423 7.7 9.53553 7.7H9.58579C9.76195 7.7 9.82414 7.70024 9.88201 7.70338C10.4052 7.73178 10.9031 7.938 11.2932 8.28791C11.3363 8.3266 11.3805 8.37041 11.505 8.49497L11.5183 8.50825C11.6248 8.61479 11.6971 8.68705 11.772 8.75424C12.3995 9.31713 13.2004 9.64888 14.0421 9.69456C14.1426 9.70002 14.2448 9.70001 14.3954 9.7L14.4142 9.7H20C21.434 9.7 22.4391 9.70149 23.1985 9.80359C23.9379 9.90299 24.3387 10.0861 24.6263 10.3737C24.9139 10.6613 25.097 11.0621 25.1964 11.8015C25.2985 12.5609 25.3 13.566 25.3 15V19C25.3 20.434 25.2985 21.4391 25.1964 22.1985C25.097 22.9379 24.9139 23.3387 24.6263 23.6263C24.3387 23.9139 23.9379 24.097 23.1985 24.1964C22.4391 24.2985 21.434 24.3 20 24.3H12C10.566 24.3 9.56091 24.2985 8.80146 24.1964C8.06214 24.097 7.66126 23.9139 7.37365 23.6263C7.08605 23.3387 6.90299 22.9379 6.80359 22.1985C6.70149 21.4391 6.7 20.434 6.7 19V10.5355Z",
                stroke: "#8A8D93",
                strokeWidth: "1.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.50018 12.6999C6.50018 12.3133 6.81358 11.9999 7.20018 11.9999H24.8002C25.1868 11.9999 25.5002 12.3133 25.5002 12.6999C25.5002 13.0865 25.1868 13.3999 24.8002 13.3999H7.20018C6.81358 13.3999 6.50018 13.0865 6.50018 12.6999Z",
                fill: "#8A8D93"
            })
        ]
    });
};
var HelpIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "9.3",
                stroke: "#8A8D93",
                strokeWidth: "1.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.6597 20.7229C15.6597 21.1109 15.3452 21.4254 14.9573 21.4254C14.5693 21.4254 14.2548 21.1109 14.2548 20.7229C14.2548 20.335 14.5693 20.0205 14.9573 20.0205C15.3452 20.0205 15.6597 20.335 15.6597 20.7229Z",
                fill: "#8A8D93"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7113 10.6021C15.094 10.4475 15.497 10.3715 15.9145 10.3715C16.4001 10.3715 16.8612 10.4649 17.2613 10.6939C17.6583 10.9179 17.9618 11.2429 18.16 11.6532C18.3594 12.0544 18.4453 12.5041 18.4453 12.9793C18.4453 13.4482 18.3625 13.8922 18.1686 14.2881L18.1661 14.2933L18.166 14.2933C17.9974 14.6305 17.7786 14.9415 17.5139 15.2265C17.305 15.4518 16.9526 15.7653 16.7474 15.9479C16.7114 15.9799 16.68 16.0078 16.6547 16.0306C16.5863 16.092 16.5181 16.1454 16.4622 16.1885C16.4472 16.2 16.4332 16.2108 16.4198 16.2211C16.379 16.2524 16.3442 16.2791 16.3062 16.3099C16.2152 16.3836 16.1237 16.4668 16.0232 16.5905C15.9127 16.7264 15.845 16.825 15.7901 16.9985C15.7283 17.1937 15.6734 17.5184 15.6734 18.1074C15.6734 18.494 15.36 18.8074 14.9734 18.8074C14.5868 18.8074 14.2734 18.494 14.2734 18.1074C14.2734 17.4464 14.3331 16.9625 14.4553 16.5763C14.5843 16.1685 14.7698 15.9129 14.9367 15.7075C15.1135 15.49 15.2798 15.3395 15.4252 15.2218C15.51 15.1532 15.5613 15.1145 15.6008 15.0847C15.6448 15.0516 15.6743 15.0294 15.7193 14.9889C15.7544 14.9574 15.7937 14.9224 15.8357 14.8849C16.0483 14.6954 16.3305 14.4438 16.4876 14.2744L16.488 14.2739C16.6675 14.0806 16.8075 13.8793 16.9125 13.6699C16.9916 13.5072 17.0453 13.2846 17.0453 12.9793C17.0453 12.6695 16.9892 12.4422 16.9053 12.2743L16.9002 12.2642L16.9003 12.2642C16.8251 12.1075 16.7198 11.9956 16.5722 11.9126L16.5667 11.9095L16.5667 11.9095C16.4314 11.8317 16.2262 11.7715 15.9145 11.7715C15.6704 11.7715 15.446 11.8153 15.2355 11.9002C15.0566 11.9725 14.9239 12.0774 14.8209 12.219C14.5935 12.5316 14.1557 12.6008 13.8431 12.3734C13.5304 12.146 13.4613 11.7082 13.6887 11.3955C13.9508 11.0352 14.2971 10.7694 14.7113 10.6021Z",
                fill: "#8A8D93"
            })
        ]
    });
};
var HomeIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.0191 11.5086L24.0192 11.5088L25.3036 14.2261C25.1511 14.2981 24.9313 14.4143 24.7402 14.582C24.5576 14.7423 24.2978 15.0427 24.2978 15.4814V20C24.2978 21.434 24.2963 22.4391 24.1942 23.1985C24.0948 23.9379 23.9117 24.3387 23.6241 24.6263C23.1985 25.052 22.5415 25.2357 20.9795 25.2829C20.4944 25.2976 20.2042 25.3047 19.9944 25.2816C19.8984 25.271 19.848 25.2564 19.8228 25.2465C19.8031 25.2387 19.7969 25.2333 19.7911 25.2277L19.7909 25.2275C19.7872 25.224 19.7818 25.2187 19.7731 25.198C19.7618 25.1713 19.7452 25.1183 19.7314 25.0181C19.7016 24.8008 19.7 24.4988 19.7 24V22L19.7 21.9533C19.7 21.2861 19.7001 20.7162 19.6388 20.2608C19.5735 19.7747 19.427 19.3158 19.0556 18.9444C18.6842 18.573 18.2253 18.4265 17.7392 18.3612C17.2838 18.2999 16.7139 18.3 16.0467 18.3L16 18.3L15.9533 18.3C15.2861 18.3 14.7162 18.2999 14.2608 18.3612C13.7747 18.4265 13.3158 18.573 12.9444 18.9444C12.573 19.3158 12.4265 19.7747 12.3612 20.2608C12.2999 20.7162 12.3 21.2861 12.3 21.9533L12.3 22V24C12.3 24.4987 12.2984 24.8007 12.2686 25.018C12.2548 25.1182 12.2382 25.1711 12.2269 25.1979C12.2182 25.2185 12.2128 25.2238 12.2091 25.2274L12.2089 25.2276C12.2032 25.2332 12.197 25.2386 12.1773 25.2463C12.152 25.2562 12.1016 25.2708 12.0055 25.2815C11.7957 25.3047 11.5054 25.2976 11.0203 25.2831C9.44869 25.236 8.78356 25.052 8.35789 24.6263L7.87302 25.1112L8.35789 24.6263C8.07029 24.3387 7.88723 23.9379 7.78783 23.1985C7.68573 22.4391 7.68424 21.434 7.68424 20L7.68424 15.4674C7.68424 15.0386 7.43603 14.742 7.25527 14.5805C7.06807 14.4132 6.85245 14.2979 6.7003 14.2261L6.40154 14.8592L6.70029 14.2261L6.70013 14.2264L7.98473 11.5088L7.98484 11.5086C8.41692 10.5936 8.64997 10.1206 9.01457 9.76232C9.37922 9.40404 9.85666 9.17911 10.7795 8.76281L10.7797 8.7627L13.6642 7.46015L13.6645 7.46002C14.7917 6.95042 15.3834 6.69683 16.002 6.69683C16.6205 6.69683 17.2122 6.95043 18.3394 7.46003L18.3397 7.46016L21.2242 8.7627L21.2244 8.76281C22.1472 9.17911 22.6247 9.40404 22.9893 9.76232C23.3539 10.1206 23.587 10.5936 24.0191 11.5086Z",
                stroke: "#8A8D93",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.61523 13.9504L10.2704 12.6211C10.4482 12.5321 10.6343 12.461 10.8262 12.4088L15.2347 11.21C15.7508 11.0697 16.295 11.0698 16.811 11.2105L21.2091 12.4096C21.3984 12.4612 21.5822 12.5313 21.7578 12.6188L24.4306 13.9504",
                stroke: "#8A8D93",
                strokeWidth: "1.4"
            })
        ]
    });
};
var Logo = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "logo-primary",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.85427 12L3.85427 3.85427L12 3.85427C16.4988 3.85427 20.1457 7.50124 20.1457 12C20.1457 13.8958 19.4981 15.6402 18.4121 17.0243L21.1509 19.7632C22.928 17.6705 24 14.9605 24 12C24 5.37258 18.6274 -8.69081e-07 12 0L3.85427 1.06818e-06L0 1.57361e-06V3.85427L1.57361e-06 12C2.44269e-06 18.6274 5.37259 24 12 24C14.3645 24 16.5694 23.3161 18.4274 22.1353L15.6008 19.3087C14.5151 19.8446 13.2927 20.1457 12 20.1457C7.50124 20.1457 3.85427 16.4988 3.85427 12Z",
            fill: "#2CA58D"
        })
    });
};
var LogoBig = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "226",
        height: "32",
        viewBox: "0 0 226 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M70.0572 0.00809033C71.1971 0.00809018 72.1212 0.932173 72.1212 2.07209C72.1212 3.212 71.1971 4.13608 70.0572 4.13608C68.9172 4.13608 67.9932 3.212 67.9932 2.07209L67.9932 0.0080906L70.0572 0.00809033Z",
                fill: "#2CA58D"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M194.159 0.00805664C195.299 0.00805649 196.223 0.932139 196.223 2.07205C196.223 3.21197 195.299 4.13605 194.159 4.13605C193.019 4.13605 192.095 3.21197 192.095 2.07205V0.00805691L194.159 0.00805664Z",
                fill: "#2CA58D"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M90.0698 20.6399H93.1658L93.1658 15.4869L94.9069 13.7458L98.8849 20.6359L102.46 20.6359L97.1733 11.4794L102.454 6.19872L102.447 6.19199L98.0823 6.19199L93.1658 11.1085V0.00805082L90.0698 0.00805136L90.0698 14.2045L90.0471 14.2273H90.0698L90.0698 20.6399Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M103.178 21.8813L103.179 21.8811L103.178 21.8805V21.8813Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M88.5823 15.692L88.5827 15.6916V15.6924L88.5823 15.692Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M88.0507 14.9639C87.342 18.2098 84.4513 20.6399 80.9929 20.6399C77.0032 20.6399 73.7689 17.4057 73.7689 13.416C73.7689 9.42626 77.0032 6.19197 80.9929 6.19197C84.4513 6.19197 87.342 8.62213 88.0507 11.8679H84.8208C84.2085 10.3551 82.7253 9.28795 80.9929 9.28795C78.7131 9.28795 76.8649 11.1361 76.8649 13.4159C76.8649 15.6958 78.7131 17.5439 80.9929 17.5439C82.7253 17.5439 84.2085 16.4768 84.8208 14.9639H88.0507Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M88.2169 13.4361C88.2169 13.4294 88.2169 13.4227 88.2169 13.416C88.2169 13.4092 88.2169 13.4025 88.2169 13.3959V13.4361Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M63.23 13.416C63.23 15.6958 61.3818 17.5439 59.102 17.5439C56.8221 17.5439 54.974 15.6958 54.974 13.416V7.48681C54.974 7.48681 54.974 7.48681 54.974 7.48681L54.974 6.19198L51.878 6.19198L51.878 13.416C51.878 17.4057 55.1123 20.64 59.102 20.64C63.0917 20.64 66.3259 17.4057 66.3259 13.416L66.326 6.19197L63.23 6.19197L63.23 13.416Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M44.5081 19.4584C43.0743 20.2129 41.4414 20.64 39.7087 20.64C34.0091 20.64 29.3887 16.0196 29.3887 10.32C29.3887 4.62041 34.0091 9.96544e-07 39.7087 0C45.4082 -9.96544e-07 50.0286 4.62041 50.0286 10.32C50.0286 13.1597 48.8816 15.7316 47.0256 17.5976L50.0286 20.6005L49.9932 20.6359H45.6856L44.5081 19.4584ZM44.8364 15.4083C46.1321 14.1026 46.9326 12.3048 46.9326 10.32C46.9326 6.33025 43.6983 3.09596 39.7086 3.09596C35.7189 3.09596 32.4846 6.33025 32.4846 10.32C32.4846 14.3097 35.7189 17.5439 39.7086 17.5439C40.5711 17.5439 41.3983 17.3928 42.1652 17.1155L40.6452 15.5956L42.8344 13.4064L44.8364 15.4083Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M68.5086 20.6399H71.6046V6.19601L68.5086 6.19601L68.5086 20.6399Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.458 20.648C126.157 20.648 130.778 16.0276 130.778 10.328C130.778 4.62846 126.157 0.00804882 120.458 0.00804982C114.758 0.00805081 110.138 4.62846 110.138 10.328C110.138 16.0276 114.758 20.648 120.458 20.648ZM120.458 17.552C124.447 17.552 127.682 14.3177 127.682 10.328C127.682 6.33831 124.447 3.10402 120.458 3.10402C116.468 3.10402 113.234 6.33831 113.234 10.328C113.234 14.3177 116.468 17.552 120.458 17.552Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153.18 6.20005L156.276 6.20005V13.4241C156.276 15.7264 155.199 17.7772 153.522 19.1C155.199 20.4229 156.276 22.4737 156.276 24.776C156.276 28.7657 153.042 32 149.052 32C145.413 32 142.402 29.3089 141.902 25.808H145.054C145.513 27.5884 147.129 28.904 149.052 28.904C151.332 28.904 153.18 27.0558 153.18 24.776C153.18 22.4986 151.336 20.6519 149.06 20.648H149.045C148.942 20.6482 148.84 20.6522 148.738 20.6598C147.959 20.5919 145.905 20.3058 144.578 19.1363C144.571 19.1307 144.565 19.1251 144.559 19.1195C144.567 19.113 144.575 19.1065 144.583 19.1C142.905 17.7772 141.828 15.7264 141.828 13.4241C141.828 9.43436 145.063 6.20007 149.052 6.20007C150.587 6.20007 152.01 6.67872 153.18 7.4949V6.20005ZM149.052 9.29605C151.331 9.29605 153.178 11.1419 153.18 13.4198V13.424C153.18 15.7025 151.334 17.5498 149.057 17.552H149.048C146.77 17.5498 144.924 15.7025 144.924 13.424C144.924 11.1442 146.773 9.29605 149.052 9.29605Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M141.828 24.7646C141.828 24.7684 141.828 24.7722 141.828 24.776C141.828 24.7798 141.828 24.7836 141.828 24.7874V24.7646Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M169.692 19.3532C168.522 20.1693 167.099 20.648 165.564 20.648C161.575 20.648 158.34 17.4137 158.34 13.424C158.34 9.43431 161.575 6.20002 165.564 6.20002C169.554 6.20002 172.788 9.43431 172.788 13.424V20.648L169.692 20.648V19.3532ZM169.692 13.424C169.692 15.7038 167.844 17.552 165.564 17.552C163.285 17.552 161.436 15.7038 161.436 13.424C161.436 11.1442 163.285 9.29601 165.564 9.29601C167.844 9.29601 169.692 11.1442 169.692 13.424Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M212.267 14.972C211.559 18.2178 208.668 20.648 205.21 20.648C201.22 20.648 197.986 17.4137 197.986 13.424C197.986 9.43431 201.22 6.20002 205.21 6.20002C208.668 6.20002 211.559 8.63018 212.267 11.876H209.038C208.425 10.3632 206.942 9.29601 205.21 9.29601C202.93 9.29601 201.082 11.1442 201.082 13.424C201.082 15.7038 202.93 17.552 205.21 17.552C206.942 17.552 208.425 16.4848 209.038 14.972H212.267Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M212.434 13.4337C212.434 13.4304 212.434 13.4272 212.434 13.424C212.434 13.4208 212.434 13.4176 212.434 13.4143V13.4337Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M220.722 8.97141C221.031 9.08868 221.276 9.23853 221.459 9.42095C221.575 9.52121 221.693 9.71533 221.788 9.921C221.853 10.0628 221.909 10.2101 221.946 10.3359H224.846C224.804 9.83012 224.73 9.19744 224.492 8.68525C224.255 8.17306 223.983 7.79343 223.548 7.44161C223.126 7.07677 222.645 6.78836 221.985 6.55382C221.326 6.31928 220.532 6.20201 219.606 6.20201C218.89 6.20201 218.209 6.31276 217.563 6.53428C216.917 6.75579 216.349 7.062 215.857 7.4529C215.366 7.84381 214.973 8.31289 214.678 8.86016C214.397 9.40743 214.257 10.0068 214.257 10.6583C214.257 11.6877 214.615 12.5672 215.331 13.2969C216.047 14.0266 217.044 14.3503 218.321 14.5718L220.832 14.9236C221.089 14.9628 221.303 15.0378 221.486 15.1317C221.7 15.2407 221.872 15.3751 222.023 15.5081C222.294 15.7752 222.432 16.1114 222.432 16.4633C222.432 16.8933 222.201 17.3872 221.822 17.6608C221.38 17.9798 220.661 18.0841 220.001 18.0841C219.495 18.0841 218.911 18.0189 218.532 17.8886C218.153 17.7583 217.837 17.5889 217.584 17.3805C217.331 17.1589 217.213 17.0198 217.1 16.8183C216.986 16.6167 216.891 16.2092 216.891 16.2092H213.982C213.982 16.7659 214.009 17.2726 214.262 17.7938C214.514 18.3151 214.797 18.7305 215.289 19.1605C215.78 19.5905 216.398 19.9488 217.142 20.2355C217.886 20.5091 218.777 20.6459 219.816 20.6459C220.701 20.6459 221.487 20.5222 222.175 20.2746C222.863 20.014 223.438 19.6817 223.902 19.2778C224.379 18.8608 224.737 18.3917 224.976 17.8705C225.214 17.3493 225.334 16.8151 225.334 16.2678C225.334 15.7727 225.242 15.3036 225.06 14.8606C224.877 14.4045 224.604 13.994 224.239 13.6292C223.874 13.2644 223.288 12.9348 222.754 12.6742C222.221 12.4005 221.733 12.3641 221.017 12.2469L218.52 11.895C218.228 11.844 218.019 11.7623 217.856 11.668C217.649 11.5481 217.516 11.4077 217.383 11.2838C217.158 11.0492 217.046 10.7626 217.046 10.4238C217.046 10.0459 217.295 9.5802 217.667 9.28792C218.034 8.99963 218.895 8.77595 219.513 8.77595C219.962 8.77595 220.413 8.84111 220.722 8.97141Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M175.551 20.648H178.647V13.424C178.647 11.1442 180.495 9.29601 182.775 9.29601C185.055 9.29601 186.903 11.1442 186.903 13.424L186.903 13.4307C186.903 13.4311 186.903 13.4315 186.903 13.4319L186.903 20.648H189.999V13.424C189.999 9.43431 186.765 6.20002 182.775 6.20003C181.24 6.20003 179.817 6.67868 178.647 7.49487V6.20002L175.551 6.20002V20.648Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M182.789 20.648H182.761C182.765 20.648 182.77 20.648 182.775 20.648C182.78 20.648 182.784 20.648 182.789 20.648Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M192.611 20.648H195.707L195.707 6.20402L192.611 6.20402V20.648Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M140.145 20.648H140.115C140.12 20.648 140.125 20.648 140.13 20.648C140.135 20.648 140.14 20.648 140.145 20.648Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M136.002 20.648L136.002 13.424L136.002 13.413C136.008 11.1382 137.854 9.29603 140.13 9.29603C140.492 9.29603 140.843 9.34267 141.178 9.43026V6.27553C140.836 6.2258 140.486 6.20005 140.13 6.20005C138.595 6.20005 137.172 6.67871 136.002 7.49489V6.20005L132.906 6.20005L132.906 20.648L136.002 20.648Z",
                fill: "#060D19"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.97776 10.3405L3.97776 3.34141L10.9769 3.34141C14.8424 3.34141 17.976 6.47502 17.976 10.3405C17.976 11.9695 17.4196 13.4684 16.4864 14.6577L18.8397 17.011C20.3666 15.2129 21.2878 12.8843 21.2878 10.3405C21.2878 4.646 16.6714 0.0296623 10.9769 0.0296631L0.666016 0.0296644L0.666017 10.3405C0.666018 16.0351 5.28235 20.6514 10.9769 20.6514C13.0086 20.6514 14.903 20.0638 16.4995 19.0492L14.0708 16.6205C13.1379 17.0809 12.0876 17.3397 10.9769 17.3397C7.11138 17.3397 3.97776 14.2061 3.97776 10.3405Z",
                fill: "#2CA58D"
            })
        ]
    });
};
var PaperWorkIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.69988 12C7.69988 10.566 7.70136 9.56091 7.80347 8.80146C7.90287 8.06214 8.08593 7.66126 8.37353 7.37365C8.66113 7.08605 9.06202 6.90299 9.80134 6.80359C10.5608 6.70149 11.5659 6.7 12.9999 6.7H18.9986C20.4326 6.7 21.4377 6.70149 22.1972 6.80359C22.9365 6.90299 23.3374 7.08605 23.625 7.37365C23.9126 7.66126 24.0956 8.06214 24.195 8.80146C24.2971 9.56091 24.2986 10.566 24.2986 12V20C24.2986 21.434 24.2971 22.4391 24.195 23.1985C24.0956 23.9379 23.9126 24.3387 23.625 24.6263C23.3374 24.9139 22.9365 25.097 22.1972 25.1964C21.4377 25.2985 20.4326 25.3 18.9986 25.3H12.9999C11.5659 25.3 10.5608 25.2985 9.80133 25.1964C9.06202 25.097 8.66113 24.9139 8.37353 24.6263C8.08593 24.3387 7.90287 23.9379 7.80347 23.1985C7.70136 22.4391 7.69988 21.434 7.69988 20V12Z",
                stroke: "#8A8D93",
                strokeWidth: "1.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11.5002",
                y: "10.9999",
                width: "9",
                height: "1.4",
                rx: "0.7",
                fill: "#8A8D93"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11.4998",
                y: "15.3009",
                width: "9",
                height: "1.40055",
                rx: "0.700274",
                fill: "#8A8D93"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11.4998",
                y: "19.5995",
                width: "5.49664",
                height: "1.40055",
                rx: "0.700274",
                fill: "#8A8D93"
            })
        ]
    });
};
var ActivityTrackerIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0.700977 15.9995C0.700977 15.2913 0.701354 14.7951 0.727821 14.4062C0.753865 14.0236 0.802819 13.7962 0.875533 13.6204C1.109 13.0558 1.55749 12.6073 2.12206 12.3739C2.29798 12.3011 2.52514 12.2522 2.90731 12.2262C3.29575 12.1997 3.7913 12.1993 4.49872 12.1993C5.20613 12.1993 5.70169 12.1997 6.09013 12.2262C6.4723 12.2522 6.69946 12.3011 6.87537 12.3739C7.43995 12.6073 7.88844 13.0558 8.1219 13.6204C8.19462 13.7962 8.24357 14.0236 8.26961 14.4062C8.29608 14.7951 8.29646 15.2913 8.29646 15.9995C8.29646 16.7077 8.29608 17.2039 8.26961 17.5928C8.24357 17.9754 8.19461 18.2027 8.1219 18.3786C7.88844 18.9431 7.43994 19.3916 6.87537 19.6251C6.69946 19.6978 6.47229 19.7468 6.09013 19.7728C5.70169 19.7993 5.20613 19.7997 4.49872 19.7997C3.7913 19.7997 3.29575 19.7993 2.9073 19.7728C2.52514 19.7468 2.29797 19.6978 2.12206 19.6251C1.55749 19.3916 1.109 18.9431 0.875534 18.3786C0.802819 18.2027 0.753865 17.9754 0.727821 17.5928C0.701354 17.2039 0.700977 16.7077 0.700977 15.9995Z",
                stroke: "#8A8C93",
                strokeWidth: "1.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0.700977 4.99788C0.700977 4.29057 0.701354 3.79508 0.727811 3.40669C0.753839 3.02458 0.802761 2.79745 0.875485 2.62155C1.10895 2.05689 1.55751 1.60832 2.12218 1.37486C2.29807 1.30214 2.52521 1.25321 2.90737 1.22719C3.29579 1.20073 3.79133 1.20035 4.49872 1.20035C5.2061 1.20035 5.70164 1.20073 6.09007 1.22719C6.47222 1.25321 6.69937 1.30214 6.87526 1.37486C7.43992 1.60832 7.88848 2.05689 8.12195 2.62156C8.19467 2.79745 8.2436 3.02458 8.26962 3.40669C8.29608 3.79508 8.29646 4.29057 8.29646 4.99788C8.29646 5.70519 8.29608 6.20068 8.26962 6.58907C8.24359 6.97118 8.19467 7.19831 8.12195 7.3742C7.88848 7.93887 7.43992 8.38743 6.87525 8.6209C6.69937 8.69362 6.47222 8.74254 6.09006 8.76857C5.70164 8.79503 5.2061 8.79541 4.49872 8.79541C3.79133 8.79541 3.29579 8.79503 2.90737 8.76857C2.52521 8.74254 2.29807 8.69362 2.12218 8.6209C1.55751 8.38743 1.10895 7.93887 0.875484 7.3742C0.802761 7.19831 0.753839 6.97118 0.727811 6.58906C0.701354 6.20068 0.700977 5.70519 0.700977 4.99788Z",
                stroke: "#8A8C93",
                strokeWidth: "1.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.6965 15.9995C11.6965 15.2909 11.6968 14.7945 11.7234 14.4055C11.7495 14.0227 11.7986 13.7952 11.8716 13.619C12.105 13.0556 12.5527 12.6079 13.1162 12.3744C13.2923 12.3015 13.5199 12.2524 13.9029 12.2262C14.2921 12.1997 14.7888 12.1993 15.4977 12.1993C16.2067 12.1993 16.7033 12.1997 17.0926 12.2262C17.4756 12.2524 17.7032 12.3015 17.8793 12.3744C18.4428 12.6079 18.8905 13.0556 19.1239 13.619C19.1969 13.7952 19.246 14.0227 19.2721 14.4055C19.2987 14.7945 19.299 15.2909 19.299 15.9995C19.299 16.7081 19.2986 17.2044 19.2721 17.5935C19.246 17.9763 19.1969 18.2038 19.1239 18.38C18.8905 18.9434 18.4428 19.3911 17.8793 19.6246C17.7032 19.6975 17.4756 19.7466 17.0926 19.7728C16.7033 19.7993 16.2067 19.7997 15.4977 19.7997C14.7888 19.7997 14.2921 19.7993 13.9029 19.7728C13.5199 19.7466 13.2923 19.6975 13.1162 19.6246C12.5527 19.3911 12.105 18.9434 11.8716 18.38C11.7986 18.2038 11.7495 17.9763 11.7234 17.5935C11.6968 17.2044 11.6965 16.7081 11.6965 15.9995Z",
                stroke: "#8A8C93",
                strokeWidth: "1.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.4978 1.19853L15.4978 8.79228",
                stroke: "#8A8C93",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.7009 4.99541L19.2947 4.99541",
                stroke: "#8A8C93",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            })
        ]
    });
};


/***/ }),

/***/ 49499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Metadata; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/config/site.ts
var WEB_ADDRESS = "https://quickorganics.com";
var SITE_NAME = "Quick Organics";

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/Metadata/index.tsx



function Metadata(param) {
    var title = param.title, _path = param.path, path = _path === void 0 ? "/" : _path, _description = param.description, description = _description === void 0 ? "Quick Organics" : _description, children = param.children;
    var url = "".concat(WEB_ADDRESS).concat(path);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "UTF-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, user-scalable=no, viewport-fit=cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: "quick organics"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/icons/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/icons/favicon-16x16.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: "/icons/safari-pinned-tab.svg",
                color: "#5bbad5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: WEB_ADDRESS
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#2b5797"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-config",
                content: "/icons/browserconfig.xml"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: "#ffffff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "format-detection",
                content: "telephone=no"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-tap-highlight",
                content: "no"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-title",
                content: SITE_NAME
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "application-name",
                content: SITE_NAME
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                href: "/icons/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/icons/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "167x167",
                href: "/icons/touch-icon-ipad-retina.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: "/icons/touch-icon-ipad.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: "/logo.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: SITE_NAME
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: "/logo.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image:alt",
                content: "twitter image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: "@quickorganics"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2048-2732.jpg",
                media: "(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2732-2048.jpg",
                media: "(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1668-2388.jpg",
                media: "(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2388-1668.jpg",
                media: "(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1536-2048.jpg",
                media: "(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2048-1536.jpg",
                media: "(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1668-2224.jpg",
                media: "(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2224-1668.jpg",
                media: "(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1620-2160.jpg",
                media: "(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2160-1620.jpg",
                media: "(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1284-2778.jpg",
                media: "(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2778-1284.jpg",
                media: "(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1170-2532.jpg",
                media: "(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2532-1170.jpg",
                media: "(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1125-2436.jpg",
                media: "(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2436-1125.jpg",
                media: "(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1242-2688.jpg",
                media: "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2688-1242.jpg",
                media: "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-828-1792.jpg",
                media: "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1792-828.jpg",
                media: "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1242-2208.jpg",
                media: "(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-2208-1242.jpg",
                media: "(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-750-1334.jpg",
                media: "(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1334-750.jpg",
                media: "(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-640-1136.jpg",
                media: "(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-startup-image",
                href: "splash/apple-splash-1136-640.jpg",
                media: "(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"
            }),
            children
        ]
    });
}
/* harmony default export */ var components_Metadata = (Metadata);


/***/ })

}]);